// Libraries
import styled from 'styled-components'
import { Link } from 'gatsby-plugin-react-i18next'

type NavMenuContainerProps = {
  footer?: boolean
}

export const NavBarContainer = styled.div<NavMenuContainerProps>`
  display: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: ${({ footer }) => (footer ? 'flex-start' : 'center')};
  justify-content: space-between;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktopMin}px) {
    flex-direction: ${({ footer }) => (footer ? 'column' : 'row')};
  }
`

export const NavBarOptions = styled(Link)<NavMenuContainerProps>`
  position: relative;
  display: flex;
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ footer }) =>
    footer
      ? ({ theme }) => theme.fontSize.small
      : ({ theme }) => theme.fontSize.xsmall};
  font-family: ${({ footer }) =>
    footer
      ? ({ theme }) => theme.fontFamily.inter
      : ({ theme }) => theme.fontFamily.lato};
  color: ${({ footer }) =>
    footer
      ? ({ theme }) => theme.colors.white00
      : ({ theme }) => theme.colors.blueDarkerLight};
  text-decoration: none;
  margin: ${({ footer }) => (footer ? '8px 0px' : '12px 0px')};
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktopMin}px) {
    margin: ${({ footer }) => (footer ? '8px 0px' : '0px 28px')};
    ::after {
        content: '';
        display: ${({ footer }) => (footer ? 'none' : 'block')};
        position: absolute;
        width: 0px;
        height: 1px;
        background: ${({ theme }) => theme.colors.blueDefault};
        border-radius: 4px;
        top: 100%;
        margin-top: 8px;
        transition: all 0.3s ease-in-out;
      }
    :hover {
      ::after {
        width: 100%;
      }
    }
    &.active {
      ::after {
        width: 100%;
      }
    }
  }
`
